export default "__VITE_ASSET__wxmVFP2X__"